import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  socialAuthPage: {
    textAlign: 'center',
    paddingTop: 48,
    maxWidth: 800
  }
})

export default useStyles
